export function _getArray(data: any): any {
  return typeof data[0] === 'object' ? data[0] : data;
}

export function _evalOperators(...params): boolean {

  const operators = ['===', '==', '||', '!=', '!==', '>', '>=', '<', '<='];
  const evalues = [];
  const array = _getArray(params);

  if (array) {
    if (array.length === 1) {
      return _eval(array[0]);
    }

    array.forEach(element => {
      evalues.push(
        operators.indexOf(element) === -1 ?
        !isNaN(element) ? element : `${element}` : element
      );
    });

    if(evalues[0] === '') {
      return false
    }

    return _eval(evalues.join('')) ? true : false;
  }
}

export function _evalOnlyBooleans(...params): boolean {
  const array = _getArray(params);

  if (array.length === 1) {
    return _eval(array[0]);
  }

  // if (array[0] === undefined) {
  //   array[0] = 'undefined';
  // }

  // if (array[0] === null) {
  //   array[0] = 'null';
  // }

  return _eval(array.join('')) ? true : false;
}

export function _eval(param) {

  if (typeof param === 'string') {
    param.replace(/''/g, '');
  }

  // tslint:disable-next-line:no-eval
  return eval(param);
}

export function _downloadFile(blob, name = 'file') {
  const downloadUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
}

export function _downloadFileGeneric(blob: any, name = 'file', fileType = 'text/plain') {
  const blobObj = new Blob([ blob ], { type : fileType });
  const downloadUrl = URL.createObjectURL(blobObj);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
}


export function downloadFileFromUrl( url: string, filename: string = 'file') {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function _currencyFormat(value) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
}

export function _keysObjectToLowerCase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(_keysObjectToLowerCase);
  }
  if (obj !== null && typeof obj === 'object') {
    const result: { [key: string]: any } = {};
    const seenKeys = new Set<string>();
    for (const key of Object.keys(obj)) {
      const lowerKey = key.toLowerCase();
      seenKeys.add(lowerKey);
      result[lowerKey] = _keysObjectToLowerCase(obj[key]);
    }
    return result;
  }
  return obj;
}





// WEBPACK FOOTER //
// ./src/app/utils/trip2-query-builder/utils/helpers.ts